const enum QueryTypes {
  noofAdults = 'noofAdults',
  priceType = 'priceType',
  noofMinors = 'noofMinors',
  noofJunior = 'noofJunior',
  priceTypes = 'priceTypes',
  priceCode = 'priceCode',
  cruiseId = 'cruiseId',
  departureDateFrom = 'departureDateFrom',
  departureDateTo = 'departureDateTo',
  macroCategory = 'macroCategory',
  numberOfNights = 'numberOfNights',
  nights = 'nights',
  embkPort = 'embkPort',
  port = 'port',
  portOfCall = 'portOfCall',
  area = 'area',
  ports = 'ports',
  ship = 'ship',
  sortBy = 'sortBy',
  sortOrder = 'sortOrder',
  hitsPerPage = 'hitsPerPage',
  page = 'page',
  includeFacets = 'includeFacets',
  includeResults = 'includeResults',
  context = 'context',
  query = 'query',
  promotion = 'promotion',
  destination = 'destination',
  tag = 'tag',
  flyAndCruise = 'flyAndCruise',
  cabins = 'cabins',
  cabin = 'cabin',
  category = 'category',
  minPrice = 'minPrice',
  maxPrice = 'maxPrice',
  priceRange = 'priceRange',
  ships = 'ships',
  adults = 'adults',
  minors = 'minors',
  juniors = 'juniors',
  paxType = 'paxType',
  startDate = 'startDate',
  endDate = 'endDate',
  cabin2Adults = 'cabin2Adults',
  cabin2Minors = 'cabin2Minors',
  cabin2Juniors = 'cabin2Juniors',
  isConnectedCabin = 'isConnectedCabin',
  firstCabinAccessibility = 'firstCabinAccessibility',
  secondCabinAccessibility = 'secondCabinAccessibility',
  priceAfterDiscount = 'priceAfterDiscount',
  pricesAfterDiscount = 'pricesAfterDiscount',
  discountCodes = 'discountCodes',
  adultPrice = 'adultPrice',
  cabinPrice = 'cabinPrice',
  perAdult = 'PerAdult',
  perCabin = 'PerCabin',
  discountedPricesBySpecificPax = 'discountedPricesBySpecificPax',
}

enum FilterTypeToFacets {
  destination = 'commArea.key',
  port = 'embkPort.key embkPort.value',
  ship = 'shipCd.key',
  category = 'category.key',
  cabin = 'macroCategory.key macroCategory.value',
  date = 'departureDateFrom departureDateTo',
  pricerange = 'pricesAfterDiscount.adultPrice pricesAfterDiscount.cabinPrice discountCodes.adultPrice discountCodes.cabinPrice',
  numberOfNights = 'numberOfNights',
  promotion = 'paxTypeTrue',
  dealpromotion = 'paxType',
  tag = 'filterTags',
  flyAndCruise = 'hasAir',
  airport = 'flights.departureAirportCode flights.departureAirportName',
  flightsDepartureAirportCode = 'flights.departureAirportCode',
  flightsDepartureAirportName = 'flights.departureAirportName',
}

enum PageTypeEnum {
  booking = '/booking',
}

enum DefaultQueryValues {
  defaultOccupancy = '2|0|0',
}

export { QueryTypes, FilterTypeToFacets, PageTypeEnum, DefaultQueryValues };
